import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';

const AuthLayout = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  const location = useLocation();

  // Pages that need full-width split layouts (hero + form)
  const splitPaths = ['/auth/login', '/auth/register', '/auth/register-organization'];
  const isSplit = splitPaths.some((p) => location.pathname.startsWith(p));

  // Wider container without card chrome for multi-column auth pages
  if (isSplit) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
        <Outlet />
      </div>
    );
  }

  // Default card layout for other auth screens
  const widePaths = ['/auth/register-options'];
  const isWide = widePaths.some((p) => location.pathname.startsWith(p));

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className={`${isWide ? 'max-w-4xl' : 'max-w-lg'} w-full bg-white p-8 rounded-xl shadow-lg border border-gray-100`}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
